import React from 'react';
import Switch from 'react-switch';
import {Formik} from 'formik';
import {TextArea} from '@react-ui-org/react-ui';
export const InputsFormularioAdmin = (props) => {
	const {empresa, handleInpuntChange, filtroShareCare, handleChangeTamañoEmpresa, isDisabled} =
		props;
	return (
		<>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Nombre prestador</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Nombre del prestador del servicio'}
						name={'nombreEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.nombreEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Nombre contacto </div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Nombre de contacto'}
						name={'nombreContactoEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.nombreContactoEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Apellidos contacto </div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Apellido de contacto'}
						name={'apellidosContactoEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.apellidosContactoEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Teléfono</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'telefono'}
						name={'telefono'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.telefono}
					/>
				</div>
			</div>

			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Dirección</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Dirección'}
						name={'direccion'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.direccion}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Código postal</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'Código postal'}
						name={'codigoPostal'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.codigoPostal}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Web Empresa</div>
				<div>
					<input
						type='text'
						className='inputTextUsuario'
						placeholder={'www.webEmpresa.com'}
						name={'webEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.webEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Email</div>
				<div>
					<input
						type='email'
						className='inputTextUsuario'
						placeholder={'empresa@email.com'}
						name={'emailEmpresa'}
						onChange={handleInpuntChange}
						disabled={isDisabled}
						value={empresa.emailEmpresa}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>Tamaño empresa</div>
				<div>
					<input
						type='number'
						className='inputTextUsuario'
						value={empresa.tamañoEmpresa}
						placeholder={1}
						name={'tamañoEmpresa'}
						onChange={handleChangeTamañoEmpresa}
						disabled={isDisabled}
					/>
				</div>
			</div>
			<div className='datoFormularioUsuario'>
				<div className='labelDatoFormUsu'>ShareCare</div>
				<div className='centrador'>
					<div className='centrador'>
						<Switch
							onChange={filtroShareCare}
							checked={empresa.shareCare}
							onColor='#23C290'
							uncheckedIcon={empresa.shareCare}
							disabled={isDisabled}
						/>
					</div>
				</div>
			</div>
			{/*
                <div className='datoFormularioUsuario'>
                    <div className='labelDatoFormUsu'>Idioma</div>
                    <Dropdown
                        options={lenguajeEmpresa}
                        onChange={selectLenguajeEmpresa}
                        value={empresa.lenguajeEmpresa}
                        placeholder="Select an option"
                    />
                </div>
                */}

			<div className='datoFormularioUsuario textarea1'>
				<div className='labelDatoFormUsu'>Descripción</div>
				<TextArea
					Id='textArea'
					placeholder={empresa.descripcionEmpresa}
					name={'descripcionEmpresa'}
					onChange={handleInpuntChange}
					fullWidth={true}
					disabled={isDisabled}
				/>
			</div>
			<div className='datoFormularioUsuario textarea2'>
				<div className='labelDatoFormUsu'>Notas</div>
				<TextArea
					Id='textArea'
					placeholder={empresa.notasEmpresa}
					name={'notasEmpresa'}
					onChange={handleInpuntChange}
					fullWidth={true}
					size='large'
					disabled={isDisabled}
				/>
			</div>
		</>
	);
};
